import { LoadableLazy } from '@confluence/loadable';

export const TemplateSuggestions = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-TemplateSuggestions" */ './TemplateSuggestions'))
			.TemplateSuggestionsComponent,
});
